var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "card shadow-sm mb-2" }, [
      _c("div", { staticClass: "card-body" }, [
        _c("label", [
          _vm._v(
            _vm._s(_vm.$t("message.booking.contact_step.has_ironing_board"))
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex" }, [
          _c("div", { staticClass: "flex-fill" }, [
            _c("div", { staticClass: "exp" }, [
              _c("div", { staticClass: "checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.preCheckoutData.has_ironing_board,
                      expression: "preCheckoutData.has_ironing_board"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    id: "hasIroningBoard",
                    name: "hasIroningBoard"
                  },
                  domProps: {
                    value: 1,
                    checked: _vm._q(_vm.preCheckoutData.has_ironing_board, 1)
                  },
                  on: {
                    change: function($event) {
                      return _vm.$set(
                        _vm.preCheckoutData,
                        "has_ironing_board",
                        1
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "mb-0", attrs: { for: "hasIroningBoard" } },
                  [
                    _c("span"),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.confirm.yes")) +
                        "\n              "
                    )
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex-fill" }, [
            _c("div", { staticClass: "exp" }, [
              _c("div", { staticClass: "checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.preCheckoutData.has_ironing_board,
                      expression: "preCheckoutData.has_ironing_board"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    id: "hasNoIroningBoard",
                    name: "hasIroningBoard"
                  },
                  domProps: {
                    value: 0,
                    checked: _vm._q(_vm.preCheckoutData.has_ironing_board, 0)
                  },
                  on: {
                    change: function($event) {
                      return _vm.$set(
                        _vm.preCheckoutData,
                        "has_ironing_board",
                        0
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "mb-0", attrs: { for: "hasNoIroningBoard" } },
                  [
                    _c("span"),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.confirm.no")) +
                        "\n              "
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.errors.has("hasIroningBoard"),
            expression: "errors.has('hasIroningBoard')"
          }
        ],
        staticClass: "text-remark pt-1 text-danger"
      },
      [
        _c("i", { staticClass: "fas fa-exclamation-triangle" }),
        _vm._v(" " + _vm._s(_vm.$t("message.required_selection")) + "\n  ")
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72e7d393", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72e7d393","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/components/HasIroningBoard.vue
// module id = 1844
// module chunks = 0